<template>
  <v-container fluid grid-list-xl>
    <v-flex xs12 md8 offset-md2 margin-auto>
      <v-flex xs12 text-xs-center mb-4>
        <div>
          <div class="left">
            <v-select value="My Quotes" :items="['My Quotes','All']" @change="getRecordsOf"></v-select>
          </div>
          <div class="right">
            <v-btn to="/quotes/new" style="padding:30px 60px; font-size:20px; " color="success">New Quote <v-icon>add</v-icon></v-btn>
          </div>
        </div>
        <div style="clear:both;">
          <v-text-field style="width:50%; margin: 0 auto;" v-model="search" append-icon="search" label="Search" single-line hide-details @change="searchQuotes()"></v-text-field>
        </div>
      </v-flex>
      <v-flex w4 text-xs-center>
        <h1 class="mb-3 pinkk">Open Quotes</h1>
        <div class="circle pinkkBorder" @click="archivedClick = false, openClick = true, ageingClick = false, searchQuotes()" :class="openClick === true ? 'circleActive' : 'pinkk'">
          <div justify-center align-center v-if="quoteLoading">
            <v-progress-circular
            indeterminate
            color="primary">
            </v-progress-circular>
          </div>
          <div v-else class="">
            {{openQuotesCount}}
          </div>
        </div>
      </v-flex>
      <v-flex w4 text-xs-center>
        <h1 class="mb-3 greyy">Ageing Quotes</h1>
        <div class="circle" @click="archivedClick = false, openClick = false, ageingClick = true, searchQuotes()" :class="ageingClick === true ? 'circleActive' : 'greyy'">
          <div justify-center align-center v-if="quoteLoading">
            <v-progress-circular
            indeterminate
            color="primary">
            </v-progress-circular>
          </div>
          <div v-else class="">
            {{ageingQuotesCount}}
          </div>
        </div>
      </v-flex>
      <v-flex w4 text-xs-center>
        <h1 class="mb-3 greyy">Archived Quotes</h1>
        <div class="circle" @click="archivedClick = true, openClick = false, ageingClick = false, searchQuotes()" :class="archivedClick === true ? 'circleActive' : 'greyy'">
          <div justify-center align-center v-if="quoteLoading">
            <v-progress-circular
            indeterminate
            color="primary">
            </v-progress-circular>
          </div>
          <div v-else class="">
            {{archivedQuotesCount}}
          </div>
        </div>
      </v-flex>
    </v-flex>
    <div style="clear:both;" class="mb-5"></div>
    <v-flex xs12 md8 offset-md2 margin-auto>
      <v-card>
        <div v-if="cmReceivedQuotes.length && archivedClick === false" class="borderPink">
          <div @click="showCMReceived = !showCMReceived" class="cmReceived">CM Received</div>
          <v-data-table v-if="showCMReceived && cmReceivedQuotes.length" :headers="headers" :items="cmReceivedQuotes" :loading="quoteLoading" :pagination.sync="pagination" :total-items="totalQuotes" :rows-per-page-items="rowsPerPageItems">
            <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
            <template slot="items" slot-scope="props">
              <td v-if="editDeleteAllowed"><v-btn small flat color="primary" target="_blank" :to="`/quotes/edit/${props.item._id}`">{{ props.item.orderCode }}</v-btn></td>
              <td v-else>{{ props.item.orderCode }}</td>
              <td v-if="props.item.customerID">{{ props.item.customerID.firstName }} {{ props.item.customerID.lastName}}</td>
              <td v-else>N/A</td>
              <td v-if="props.item.updatedBy">{{props.item.updatedBy.firstName}}</td>
              <td v-else-if="props.item.createdBy">{{props.item.createdBy.firstName}}</td>
              <td>${{ props.item.subTotal.toFixed(2) }}</td>
              <td>{{ new Date(props.item.date).getDate() + "/" + (new Date(props.item.date).getMonth() + 1) + "/" + new Date(props.item.date).getFullYear() }}</td>
              <td>
                <v-select @change="quoteActions" :items="actionItems(props)" label="Actions"></v-select>
              </td>
            </template>
            <template slot="no-data">
              {{ loadingText }}
            </template>
            <template slot="no-results">
              Your search for '{{ search }}' didn't return any results.
            </template>
          </v-data-table>
        </div>
        <v-data-table :headers="headers" :items="quotes" :loading="quoteLoading" :pagination.sync="pagination" :total-items="totalQuotes" :rows-per-page-items="rowsPerPageItems">
          <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
          <template slot="items" slot-scope="props">
            <td v-if="editDeleteAllowed"><v-btn small flat color="primary" target="_blank" :to="`/quotes/edit/${props.item._id}`">{{ props.item.orderCode }}</v-btn></td>
            <td v-else>{{ props.item.orderCode }}</td>
            <td v-if="props.item.customerID">{{ props.item.customerID.firstName }} {{ props.item.customerID.lastName}}</td>
            <td v-else>N/A</td>
            <td v-if="props.item.updatedBy">{{props.item.updatedBy.firstName}}</td>
            <td v-else-if="props.item.createdBy">{{props.item.createdBy.firstName}}</td>
            <td v-else></td>
            <td>${{ props.item.subTotal.toFixed(2) }}</td>
            <td>{{ new Date(props.item.date).getDate() + "/" + (new Date(props.item.date).getMonth() + 1) + "/" + new Date(props.item.date).getFullYear() }}</td>
            <td>
              <v-select @change="quoteActions" :items="actionItems(props)" label="Actions"></v-select>
            </td>
          </template>
          <template slot="no-data">
            {{ loadingText }}
          </template>
          <template slot="no-results">
            Your search for '{{ search }}' didn't return any results.
          </template>
        </v-data-table>
      </v-card>
    </v-flex>
    <div class="text-center">
      <v-dialog
        v-model="dialog"
        width="500"
      >
        <v-card>
          <v-card-title
            class="headline grey lighten-2"
            primary-title
          >
            Download CM
          </v-card-title>

          <v-card-text>
            <div v-for="(CM, index) in CMs" :key="'bb' + index" class="level">
              <v-container fluid grid-list-xl>
                <v-layout row wrap>
                  <!-- <v-flex xs12 sm6 v-if="CM.exist"> -->
                  <v-flex xs12 sm6>
                    <a @click="downloadCheckMeasure(CM.file)" class="level-item">{{CM.file}}</a>
                  </v-flex>
                  <!-- <v-flex v-else>
                    {{CM.file}} &nbsp;&nbsp;&nbsp;&nbsp; <span style="color:red">(file not exist)</span>
                  </v-flex> -->
                </v-layout>
              </v-container>
            </div>
            <!-- <v-btn
              color="primary"
              text
              @click="downloadAll()"
            >
              Download All
            </v-btn> -->

          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="dialog = false"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <v-dialog v-model="paymentDialog" max-width="600px" v-if="selectedIndex !== null">
      <v-card>
        <v-card-title>
          <h4>Payment</h4>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-select v-model="quotes[selectedIndex].paymentStatus" label="Payment Status" :items="['Full Payment', 'Deposit Paid']"></v-select>
          <v-text-field v-model="quotes[selectedIndex].paidAmount" label="Deposit Amount" v-if="quotes[selectedIndex].paymentStatus === 'Deposit Paid'"></v-text-field>
        </v-card-text>
        <v-card-text v-if="quotes[selectedIndex].install > 0">
          <v-label>Check Measure Required?</v-label>
          <v-radio-group v-model="quotes[selectedIndex].cmRequired" row @click="changecmFormLink">
            <v-radio label="Yes" color="primary" value="yes"></v-radio>
            <v-radio label="No" color="primary" value="no"></v-radio>
            <v-radio label="Completed" color="primary" value="completed"></v-radio>
          </v-radio-group>
          <div v-if="cmFormLink != '' && (quotes[selectedIndex].cmRequired === 'yes' || quotes[selectedIndex].cmRequired === 'completed') ">
            <v-card-title>
              <h2 v-if="quotes[selectedIndex].cmRequired === 'yes'">{{shippingState}} CM Request Form</h2>
              <h2 v-if="quotes[selectedIndex].cmRequired === 'completed'">{{shippingState}} Install Request Form</h2>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text v-html="cmFormLink">
            </v-card-text>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="success" @click="updatePayment()">Submit</v-btn>
          <v-btn color="primary" @click="paymentDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="cmRequiredDialog" max-width="600px" v-if="selectedIndex !== null">
      <v-card>
        <v-card-title>
          <h2>Are you sure?</h2>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-flex xs12 sm12 mb-3 cursor-pointer @click="showNotes = !showNotes"><h1>Notes ({{quotes[selectedIndex].installationNotes.length}})</h1></v-flex>
          <div v-if="showNotes">
            <div v-for="(note, index) in quotes[selectedIndex].installationNotes" :key="'aa' + index" class="level">
              <v-layout row wrap>
                <v-flex xs12 sm12 mb-3>
                  <div class="note-date">{{ getNoteDate(note.date) }}</div>
                  <div class="note-name-time">{{note.username}} - {{getNoteTime(note.date)}}</div>
                  <div class="note-note">{{note.note}}</div>
                </v-flex>
                <!-- <v-flex xs12 sm6>
                  <v-icon @click.prevent="quotes[selectedIndex].installationNotes.splice(index, 1)">delete</v-icon>
                </v-flex> -->
              </v-layout>
            </div>
          </div>
          <v-textarea v-model="installationNote" label="Installation Notes"></v-textarea>
          <v-flex xs12 sm12 text-sm-right>
            <v-btn @click="addNote()" color="success">Add Note</v-btn>
          </v-flex>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="success" @click="updateInstallationStatus()">Submit</v-btn>
          <v-btn color="primary" @click="cmRequiredDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar dark top v-model="snackbar" :timeout="3000">
      {{ popupText }}
      <v-btn dark flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import OrderService from '@/services/OrderService'
import _ from 'lodash'
import moment from 'moment'

var xlsx = require('xlsx')
var gConfig
if (process.env.NODE_ENV === 'production') {
  gConfig = require('../../../gConfigProduction.json')
} else if (process.env.NODE_ENV === 'staging') {
  gConfig = require('../../../gConfigStaging.json')
} else {
  gConfig = require('../../../gConfig.json')
}

export default {
  name: 'quotes',
  data () {
    return {
      cmFormLink: '',
      shippingState: '',
      quoteAge: 'open',
      openClick: true,
      ageingClick: false,
      archivedClick: false,
      openQuotesCount: 0,
      ageingQuotesCount: 0,
      archivedQuotesCount: 0,
      showCMReceived: false,
      showNotes: false,
      installationNote: '',
      CMs: [],
      dialog: false,
      paymentDialog: false,
      cmRequiredDialog: false,
      headers: [
        { text: 'Order Code', value: 'orderCode' },
        { text: 'Customer Name', value: 'customerName' },
        { text: 'User', value: 'User' },
        { text: 'Total', value: 'total' },
        { text: 'Date', value: 'date' },
        { text: 'Actions', value: 'actions' }
      ],
      editDeleteAllowed: true,
      selectedIndex: null,
      quotes: [],
      cmReceivedQuotes: [],
      snackbar: false,
      popupText: null,
      quoteLoading: false,
      search: null,
      enabledUsers: [],
      availableUsers: [],
      pagination: {
        sortBy: 'date',
        descending: true,
        rowsPerPage: 30
      },
      totalQuotes: 0,
      loadingText: 'Loading...',
      rowsPerPageItems: [10, 20, 30],
      loggedInUser: JSON.parse(atob(localStorage.getItem('user'))),
      showRecords: 'MyQuotes'
    }
  },
  watch: {
    pagination: {
      handler () {
        this.getQuotes().then(data => {
          this.quotes = data
        })
      },
      deep: true
    }
  },
  mounted () {
    if (localStorage.getItem('is_admin') === 'true') {
      this.editDeleteAllowed = false
    } else {
      this.editDeleteAllowed = true
    }
    this.checkForNotifications()
    // this.getCounts()
    // this.getQuoteUsers()
    // this.getQuotes()
  },
  methods: {
    async getCounts () {
      let response = {}
      if (this.showRecords === 'MyQuotes') {
        response = await OrderService.getQuotesAndArchivedCounts({userID: this.loggedInUser._id, search: this.search})
        this.enabledUsers = [this.loggedInUser._id]
      } else {
        response = await OrderService.getQuotesAndArchivedCounts({userID: 'all', search: this.search})
        this.enabledUsers = []
      }
      this.openQuotesCount = response.data.latestQuotesCount
      this.ageingQuotesCount = response.data.ageingQuotesCount
      this.archivedQuotesCount = response.data.archivedCount
      console.log(response)
    },
    async getQuoteUsers () {
      const totalUserResponse = await OrderService.usersQuotes()
      let users = totalUserResponse.data.users
      let temp = []
      let userList = []
      users.map(function (value, key) {
        if (value.createdBy) {
          if (!temp.includes(value.createdBy._id) && value.createdBy.firstName) {
            // console.log(value)
            userList.push({ id: value.createdBy._id, firstName: value.createdBy.firstName })
            temp.push(value.createdBy._id)
          }
        }
        if (value.updatedBy) {
          if (!temp.includes(value.updatedBy._id) && value.updatedBy.firstName) {
            // console.log(value)
            userList.push({ id: value.updatedBy._id, firstName: value.updatedBy.firstName })
            temp.push(value.updatedBy._id)
          }
        }
      })
      this.availableUsers = userList
      // console.log(userList)
    },
    async getQuotes () {
      this.quoteLoading = true

      this.getCounts()

      const { sortBy, descending, page, rowsPerPage } = this.pagination

      if (this.showRecords === 'MyQuotes') {
        this.enabledUsers = [this.loggedInUser._id]
      } else {
        this.enabledUsers = []
      }

      let response = {}
      // if (this.archivedClick === true) {
      //   response = await OrderService.fetchLimitedArchivedOrders(page, rowsPerPage, this.search, this.enabledUsers)
      // } else {
      //   response = await OrderService.fetchlimitedQuotes(page, rowsPerPage, this.search, this.enabledUsers)
      // }
      if (this.openClick === true) {
        this.quoteAge = 'open'
      } else if (this.ageingClick) {
        this.quoteAge = 'ageing'
      } else if (this.archivedClick === true) {
        this.quoteAge = 'archived'
      }
      response = await OrderService.fetchlimitedQuotes2(page, rowsPerPage, this.search, this.enabledUsers, this.quoteAge)

      for (var index in response.data.orders) {
        // For each quote, get the items
        // const itemQuoteResponse = await OrderService.getItems(response.data.orders[index]._id)
        // itemQuoteResponse.data.items.forEach(function (item) {
        //   // response.data.orders[index].subTotal += item.total
        // })

        // Add shipping, etc
        response.data.orders[index].subTotal += response.data.orders[index].shipping
        response.data.orders[index].subTotal += response.data.orders[index].install
        response.data.orders[index].subTotal += response.data.orders[index].measure
        response.data.orders[index].subTotal += response.data.orders[index].insurance
        response.data.orders[index].subTotal -= response.data.orders[index].discount

        response.data.orders[index].checkCMExist = false
        if (response.data.orders[index].checkMeasureImg.length > 0) {
          response.data.orders[index].checkCMExist = true
        }
      }

      let items = response.data.orders
      // console.log(items)
      var date = new Date()
      var date2 = new Date()
      date.setMonth(date.getMonth() - 1)
      date2.setMonth(date2.getMonth() - 2)
      // let filteredItems = {}
      // if (this.openClick === true) {
      //   filteredItems = items.filter(function (order) {
      //     return (order.lastUpdated && new Date(order.lastUpdated).getTime() >= date.getTime()) || (!order.lastUpdated && new Date(order.date).getTime() >= date.getTime())
      //   })
      //   items = filteredItems
      // } else if (this.ageingClick === true) {
      //   filteredItems = items.filter(function (order) {
      //     return (order.lastUpdated && new Date(order.lastUpdated).getTime() < date.getTime() && new Date(order.lastUpdated).getTime() >= date2.getTime()) || (!order.lastUpdated && new Date(order.date).getTime() < date.getTime() && new Date(order.date).getTime() >= date2.getTime())
      //   })
      //   items = filteredItems
      // } else
      if (this.archivedClick === true) {
        // filteredItems = items.filter(function (order) {
        //   return (order.lastUpdated && new Date(order.lastUpdated).getTime() <= date2.getTime()) || (!order.lastUpdated && new Date(order.date).getTime() <= date2.getTime())
        // })
        let response2 = await OrderService.fetchLimitedArchivedOrders(page, rowsPerPage, this.search, this.enabledUsers)
        for (var index2 in response2.data.orders) {
          // Add shipping, etc
          response2.data.orders[index2].subTotal += response2.data.orders[index2].shipping
          response2.data.orders[index2].subTotal += response2.data.orders[index2].install
          response2.data.orders[index2].subTotal += response2.data.orders[index2].measure
          response2.data.orders[index2].subTotal += response2.data.orders[index2].insurance
          response2.data.orders[index2].subTotal -= response2.data.orders[index2].discount

          response2.data.orders[index2].checkCMExist = false
          if (response2.data.orders[index2].checkMeasureImg && response2.data.orders[index2].checkMeasureImg.length > 0) {
            response2.data.orders[index2].checkCMExist = true
          }
        }
        items = [...items, ...response2.data.orders]
      }
      // console.log(items)
      if (this.pagination.sortBy) {
        items = items.sort((a, b) => {
          const sortA = a[sortBy]
          const sortB = b[sortBy]

          if (descending) {
            if (sortA < sortB) return 1
            if (sortA > sortB) return -1
            return 0
          } else {
            if (sortA < sortB) return -1
            if (sortA > sortB) return 1
            return 0
          }
        })
      }
      if (this.archivedClick === true) {
        this.totalQuotes = this.archivedQuotesCount
      } else if (this.openClick === true) {
        this.totalQuotes = this.openQuotesCount
      } else if (this.ageingClick === true) {
        this.totalQuotes = this.ageingQuotesCount
      } else {
        // const totalResponse = await OrderService.countQuotes(this.search, this.enabledUsers)
        // this.totalQuotes = totalResponse.data.count
      }

      if (this.totalQuotes === 0) {
        this.loadingText = 'No Quotes Found.'
      }

      this.quoteLoading = false
      let vm = this
      this.cmReceivedQuotes = items.filter(function (quote) {
        if (quote.updatedBy) {
          return quote.updatedBy._id === vm.loggedInUser._id && quote.installationStatus === 'CM Received' && !quote.parentOrderCode
        } else if (quote.createdBy) {
          return quote.createdBy._id === vm.loggedInUser._id && quote.installationStatus === 'CM Received' && !quote.parentOrderCode
        }
        return false
      })

      return items
    },
    async checkMeasureImgExistOrNot (CMImg) {
      var response = await OrderService.checkfileexist(CMImg)
      return response.data.status
    },
    async downloadCheckMeasure (CMImg) {
      this.checkMeasureImgExistOrNot(CMImg).then(function (val) {
        if (val) {
          window.open(gConfig.apiURL + '/downloadCheckMeasure?file=' + CMImg)
        } else {
          window.open(gConfig.mediaURL + '/API/checkMeasures/' + CMImg)
        }
      })
      // window.open(gConfig.apiURL + '/downloadCheckMeasure?file=' + CMImg)
      // window.open(gConfig.mediaURL + '/API/checkMeasures/' + CMImg)
      return true
    },
    // downloadAll () {
    //   this.CMs.forEach(CMImg => {
    //     setTimeout(async () => {
    //       console.log(CMImg)
    //       await this.downloadCheckMeasure(CMImg)
    //     }, 1000);
    //   })
    // },
    async searchQuotes () {
      this.quotes = await this.getQuotes()
    },

    // async archiveQuote (id) {
    //   await OrderService.archiveOrder(id)
    //   this.getQuotes()
    // },

    async duplicateQuote (id) {
      await OrderService.duplicateOrder(id)
      this.getQuotes()
    },

    async upgradeQuote (id) {
      await OrderService.upgradeQuote(id)
      this.getQuotes()
    },

    async pdfQuote (id, orderCode) {
      const response = await OrderService.getOrderQuote(id)
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', orderCode + '.pdf')
      document.body.appendChild(link)
      link.click()
      link.remove()

      this.popupText = 'PDF quote generated'
      this.snackbar = true
    },

    async pdfInvoice (id, orderCode) {
      console.log('getting invoice')
      const response = await OrderService.getOrderInvoice(id)
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', orderCode + '.pdf')
      document.body.appendChild(link)
      link.click()
      link.remove()

      this.popupText = 'PDF invoice generated'
      this.snackbar = true
    },

    async prettyQuote (id, orderCode) {
      const response = await OrderService.getPrettyOrderQuote(id)
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', orderCode + '.pdf')
      document.body.appendChild(link)
      link.click()
      link.remove()

      this.popupText = 'PDF pretty quote generated'
      this.snackbar = true
    },
    async homeproQuote (id, orderCode) {
      const response = await OrderService.getHomeproOrderQuote(id)
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', orderCode + '.pdf')
      document.body.appendChild(link)
      link.click()
      link.remove()

      this.popupText = 'PDF pretty quote generated'
      this.snackbar = true
    },
    async prettyQuoteOld (id, orderCode) {
      const response = await OrderService.getPrettyOrderQuoteOld(id)
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', orderCode + '.pdf')
      document.body.appendChild(link)
      link.click()
      link.remove()

      this.popupText = 'PDF pretty quote generated'
      this.snackbar = true
    },

    downloadXLSX () {
      var table = document.getElementById('quoteTable')
      var workbook = xlsx.utils.table_to_book(table, {sheet: 'Quotes'})
      return xlsx.writeFile(workbook, ('Orders.xlsx'))
    },

    async quoteActions (value) {
      switch (value.action) {
        case 'archive':
          await OrderService.updateOrderStatus(value.id, 'Archived')
          this.getQuotes()
          break
        case 'duplicate':
          const duplicateResponse = await OrderService.duplicateOrder(value.id)
          if (duplicateResponse.data.success) {
            this.popupText = `Quote duplicated successfully. Quote ${duplicateResponse.data.order.orderCode} created.`
            this.snackbar = true
          }
          this.quotes = await this.getQuotes()
          break
        case 'email':
          const emailResponse = await OrderService.emailQuote(value.id)
          if (emailResponse.data.success) {
            this.popupText = 'Email sent successfully.'
            this.snackbar = true
          }
          break
        case 'pdf':
          this.pdfQuote(value.id, value.orderCode)
          break
        case 'pdfInvoice':
          this.pdfInvoice(value.id, value.orderCode)
          break
        case 'pretty':
          this.prettyQuote(value.id, value.orderCode)
          break
        case 'prettyOld':
          this.prettyQuoteOld(value.id, value.orderCode)
          break
        case 'homepro':
          this.homeproQuote(value.id, value.orderCode)
          break
        case 'CM':
          this.CMs = []
          let vm = this
          _.forEach(value.CMImg, item => {
            var exist = false
            this.checkMeasureImgExistOrNot(item).then(function (val) {
              exist = val
              let obj = {file: item, exist: exist}
              vm.CMs.push(obj)
            })
          })
          this.dialog = true
          break
        case 'order':
          const orderResponse = await OrderService.upgradeQuote(value.id)
          if (orderResponse.data.success) {
            this.popupText = 'Quote upgraded successfully.'
            this.snackbar = true
            this.getQuotes()
          }
          this.selectedIndex = null
          break
        case 'cmRequired':
          this.selectedIndex = value.index
          this.cmRequiredDialog = true
          break
        case 'cmSheet':
          const response = await OrderService.downloadCMSheet(value.id)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `CMSheet-${value.orderCode}.xlsx`)
          document.body.appendChild(link)
          link.click()
          link.remove()

          this.popupText = 'CMSheet XLSX generated.'
          this.snackbar = true
          break
        case 'checkPayment':
          this.selectedIndex = value.index
          this.shippingState = ''
          this.changecmFormLink()
          this.paymentDialog = true
          break
      }
    },
    changecmFormLink () {
      this.cmFormLink = ''
      let order = this.quotes[this.selectedIndex]
      let state = ''
      if (order.address && order.address.state) {
        state = order.address.state
      } else {
        if (order.differentShippingAddress === true) {
          state = order.customerID.shippingAddress.slice(-1)[0].state
        } else {
          state = order.customerID.address.state
        }
      }
      console.log(state)
      if (state === 'VIC') {
        this.shippingState = 'VIC'
        if (this.quotes[this.selectedIndex].cmRequired === 'yes') {
          this.cmFormLink = '<a href="https://forms.gle/E7n5LJZWSXwHiSAY6" target="_blank">https://forms.gle/E7n5LJZWSXwHiSAY6</a>'
        } else if (this.quotes[this.selectedIndex].cmRequired === 'completed') {
          this.cmFormLink = '<a href="https://forms.gle/EsvsWMP7eG1b8ePh9" target="_blank">https://forms.gle/EsvsWMP7eG1b8ePh9</a>'
        }
      }
      if (state === 'NSW') {
        this.shippingState = 'NSW'
        if (this.quotes[this.selectedIndex].cmRequired === 'yes') {
          this.cmFormLink = '<a href="https://forms.gle/79AEZNe9shU9zmtCA" target="_blank">https://forms.gle/79AEZNe9shU9zmtCA</a>'
        } else if (this.quotes[this.selectedIndex].cmRequired === 'completed') {
          this.cmFormLink = '<a href="https://forms.gle/x3fPsjNS5db289Yq8" target="_blank">https://forms.gle/x3fPsjNS5db289Yq8</a>'
        }
      }
      if (state === 'QLD') {
        this.shippingState = 'QLD'
        if (this.quotes[this.selectedIndex].cmRequired === 'yes') {
          this.cmFormLink = '<a href="https://forms.gle/FCP5MTXVdEwwD4jKA" target="_blank">https://forms.gle/FCP5MTXVdEwwD4jKA</a>'
        } else if (this.quotes[this.selectedIndex].cmRequired === 'completed') {
          this.cmFormLink = '<a href="https://forms.gle/NjbfNmoriP1cpN137" target="_blank">https://forms.gle/NjbfNmoriP1cpN137</a>'
        }
      }
      if (state === 'SA') {
        this.shippingState = 'SA'
        if (this.quotes[this.selectedIndex].cmRequired === 'yes') {
          this.cmFormLink = '<a href="https://forms.gle/yDegNygt8b3hG6PA9" target="_blank">https://forms.gle/yDegNygt8b3hG6PA9</a>'
        } else if (this.quotes[this.selectedIndex].cmRequired === 'completed') {
          this.cmFormLink = '<a href="https://forms.gle/nTRnR1PKspD9B5AQ7" target="_blank">https://forms.gle/nTRnR1PKspD9B5AQ7</a>'
        }
      }
    },
    getRecordsOf (value) {
      if (value === 'All') {
        this.showRecords = 'All'
      } else {
        this.showRecords = 'MyQuotes'
      }
      this.getCounts()
      this.searchQuotes()
    },
    async updateInstallationStatus () {
      let order = this.quotes[this.selectedIndex]
      let params = {id: order._id, installationStatus: 'CM Required'}
      let response = await OrderService.updateInstallationStatus(params)
      if (response.data.success) {
        this.popupText = 'Installation status updated successfully.'
        this.snackbar = true
        this.cmRequiredDialog = false
        this.getQuotes()
      }
    },
    async updateInstallationNotes () {
      let order = this.quotes[this.selectedIndex]
      let params = {id: order._id, installationNotes: order.installationNotes}
      let response = await OrderService.updateInstallationNotes(params)
      if (response.data.success) {
        this.popupText = 'Installation notes updated successfully.'
        this.snackbar = true
      }
    },
    async updatePayment () {
      // revert subtotal on update
      this.quotes[this.selectedIndex].subTotal -= this.quotes[this.selectedIndex].shipping
      this.quotes[this.selectedIndex].subTotal -= this.quotes[this.selectedIndex].install
      this.quotes[this.selectedIndex].subTotal -= this.quotes[this.selectedIndex].measure
      this.quotes[this.selectedIndex].subTotal -= this.quotes[this.selectedIndex].insurance
      this.quotes[this.selectedIndex].subTotal += this.quotes[this.selectedIndex].discount

      const orderResponse = await OrderService.updateOrder(this.quotes[this.selectedIndex])

      // again recalculate
      this.quotes[this.selectedIndex].subTotal += this.quotes[this.selectedIndex].shipping
      this.quotes[this.selectedIndex].subTotal += this.quotes[this.selectedIndex].install
      this.quotes[this.selectedIndex].subTotal += this.quotes[this.selectedIndex].measure
      this.quotes[this.selectedIndex].subTotal += this.quotes[this.selectedIndex].insurance
      this.quotes[this.selectedIndex].subTotal -= this.quotes[this.selectedIndex].discount

      if (orderResponse.data.success) {
        this.quoteActions({action: 'order', id: this.quotes[this.selectedIndex]._id})
        this.selectedIndex = null
      }
    },
    checkForNotifications () {
      if (this.$route.params.created) {
        this.popupText = `Quote '${this.$route.params.created}' created.`
        this.snackbar = true
      }
    },
    actionItems (props) {
      let returnArray = []
      returnArray.push({text: 'Archive', value: {action: 'archive', id: props.item._id}})
      returnArray.push({text: 'Duplicate', value: {action: 'duplicate', id: props.item._id}})
      if (props.item.install > 0) {
        returnArray.push({text: 'CM Required', value: {action: 'cmRequired', id: props.item._id, installationNotes: props.item.installationNotes, index: props.index}})
        returnArray.push({text: 'Download CM Sheet', value: {action: 'cmSheet', id: props.item._id, orderCode: props.item.orderCode}})
      }
      returnArray.push({text: 'Email Quote', value: {action: 'email', id: props.item._id}})
      returnArray.push({text: 'Download Quote', value: {action: 'pdf', id: props.item._id, orderCode: props.item.orderCode}})
      returnArray.push({text: 'Download Invoice', value: {action: 'pdfInvoice', id: props.item._id, orderCode: props.item.orderCode}})
      returnArray.push({text: 'Download Pretty Quote', value: {action: 'pretty', id: props.item._id, orderCode: props.item.orderCode}})
      returnArray.push({text: 'Download Homepro Quote', value: {action: 'homepro', id: props.item._id, orderCode: props.item.orderCode}})
      returnArray.push({text: 'Download Old Pretty Quote', value: {action: 'prettyOld', id: props.item._id, orderCode: props.item.orderCode}})
      if (props.item.checkCMExist) {
        returnArray.push({text: 'Download CM', value: {action: 'CM', id: props.item._id, orderCode: props.item.orderCode, CMImg: props.item.checkMeasureImg}})
      }
      returnArray.push({text: 'Process Order', value: {action: 'checkPayment', id: props.item._id, item: props.item, index: props.index}})
      return returnArray
    },
    addNote () {
      let note = {username: this.loggedInUser.firstName, date: new Date(), note: this.installationNote}
      this.quotes[this.selectedIndex].installationNotes.push(note)
      this.installationNote = ''
      this.updateInstallationNotes()
    },
    getNoteDate (date) {
      return moment(date).format('Do MMM YYYY')
    },
    getNoteTime (date) {
      return moment(date).format('h:mmA')
    }
  }
}
</script>
<style scoped>
.circle {
  width: 300px;
  height: 300px;
  border: 3px solid #565e6f;
  margin: 0 auto;
  border-radius: 50%;
  font-size: 72px;
  font-weight: bold;
  color: #565e6f;
  line-height: 300px;
  text-align: center;
  cursor: pointer;
  padding-top: 0;
}
.pinkkBorder {
  border: 3px solid #ea4d76;
}
.pinkk {
  color: #ea4d76;
}
.greyy {
  color: #565e6f;
}
.greenn {
  color:#19ec81;
}
.w6 {
  width: 50%;
  float: left;
}
.w4 {
  width: 33.33%;
  float: left;
}
.circleActive {
  background: #4caf50 !important;
  color: #ffffff !important;
}
@media screen and (max-width: 661px) {
  .w4{
    width:100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/quotes/Quotes.vue